import { ApiError } from '@/shared/api';

/** Mensagem para falhas comuns das telas de auth (limite, rede, origem). */
export function authErrorMessage(error: unknown, fallback: string): string {
  if (!(error instanceof ApiError)) return fallback;
  if (error.status === 429) return 'Muitas tentativas. Aguarde um minuto e tente de novo.';
  if (error.isUnavailable) return 'Não foi possível falar com o servidor. Verifique sua conexão.';
  if (error.code === 'AUTH_ORIGIN_NOT_ALLOWED') {
    return 'Este endereço não é a origem configurada para o JAF. Acesse pelo endereço configurado.';
  }
  return error.detail ?? fallback;
}
